var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBook = function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1h4.667a3.11 3.11 0 0 1 3.11 3.111V15a2.333 2.333 0 0 0-2.333-2.333H1zM16.555 1H11.89a3.11 3.11 0 0 0-3.112 3.111V15a2.333 2.333 0 0 1 2.334-2.333h5.444z"
  }))));
};
export default SvgBook;